/**
 * Veeroute.Delivery
 * Veeroute Delivery API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { JobFactDelivery } from './jobFact';


/**
 * Fact.
 */
export interface OrderFactDelivery { 
    /**
     * Fact type.
     */
    type: OrderFactDeliveryTypeEnum;
    /**
     * Fact time in the [RFC 3339, section 5.6 (ISO8601)](https://tools.ietf.org/html/rfc3339#section-5.6) format.
     */
    time: string;
    /**
     * Order key.
     */
    order_key: string;
    /**
     * List of job\'s facts.
     */
    job_facts?: Array<JobFactDelivery>;
}
export enum OrderFactDeliveryTypeEnum {
    DONE = 'DONE',
    CANCEL = 'CANCEL',
    PROGRESS = 'PROGRESS'
};



